<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="editTemplate">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4 class="text-capitalize">{{ title }}</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <div v-if="type.toLowerCase() === 'speed'">
                        <v-row>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="speedFormData['label']" autofocus
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              density="compact" label="Label"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="speedFormData['speed_threshold']" :rules="[vRules.required]"
                                              density="compact"
                                              :label="`Speed Threshold (${speedUnitLabel})`" type="number"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="speedFormData['minimum_violations_in_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Minimum Violations in Seconds" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="speedFormData['minimum_alert_interval_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Minimum Alert interval Seconds" type="number"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'light'">
                        <v-row>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="lightSensorFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              density="compact" label="Label"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="lightSensorFormData['lux_value']"
                                              :rules="[vRules.required]"
                                              density="compact" label="LUX Value" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="lightSensorFormData['light_profile']"
                                          :items="[
                                              {value:1, title: 'Low Sensitivity'},
                                              {value:2, title: 'Normal'},
                                              {value:3, title: 'High Sensitivity'},
                                              ]" :rules="[vRules.required]"
                                          density="compact"
                                          label="Light Profile"
                                />
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="lightSensorFormData['debounce_interval_in_seconds']"
                                          :items="[1,2,3,4,5,6,7,8,9,10]"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Debounce time in seconds"
                                />
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="lightSensorFormData['reporting_interval_in_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact" label="Reporting interval in seconds"
                                              type="number"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-switch v-model="lightSensorFormData['light_to_dark']"
                                          color="primary"
                                          density="compact"
                                          label="Light to dark"
                                />
                            </v-col>

                            <v-col cols="6">
                                <v-switch v-model="lightSensorFormData['dark_to_light']"
                                          color="primary"
                                          density="compact"
                                          label="Dark to light"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'temperature'">
                        <v-row>
                            <v-col cols="6">
                                <v-switch v-model="temperatureSensorFormData['low_reporting_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="Low Rporting Status"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-switch v-model="temperatureSensorFormData['high_reporting_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="High Reporting Status"
                                />
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="temperatureSensorFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              density="compact" label="Label"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="temperatureSensorFormData['low_threshold_celsius']"
                                              :rules="[vRules.required]"
                                              density="compact" label="Low threshold in celsius" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="temperatureSensorFormData['high_threshold_celsius']"
                                              :rules="[vRules.required]"
                                              density="compact" label="High threshold in celsius" type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="temperatureSensorFormData['debounce_interval_in_seconds']"
                                          :items="[1,2,3,4,5,6,7,8,9,10]"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Debounce time in seconds"
                                />
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="temperatureSensorFormData['reporting_interval_in_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact" label="Reporting interval in seconds"
                                              type="number"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'geofence'">
                        <v-row>
                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="geofenceFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              density="compact" label="Label"/>
                            </v-col>
                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="geofenceFormData['trigger_delay']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Trigger delay" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="geofenceFormData['minimum_violation_time']"
                                              :rules="[vRules.required]" density="compact"
                                              label="Min. violation time" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12">
                                <v-select v-model="geofenceFormData['enter_or_exit']"
                                          :items="[
                                              {value:1,title:'Enter Only'},
                                              {value:2,title:'Exit Only'},
                                              {value:3,title:'Both'},
                                          ]" :rules="[vRules.required]"
                                          density="compact"
                                          label="Report violation event"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" style="height: 350px">
                                <l-map ref="mapContainer" @ready="mapIsReady">
                                    <l-tile-layer :url="$mapTiles.street"/>
                                </l-map>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'ble_tag' || type.toLowerCase() === 'wifi_tag'">
                        <v-row>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              density="compact" label="Label"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['scan_interval_in_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact" hint="Seconds" label="Scan interval" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['scan_window_in_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact" hint="Seconds" label="Scan window" type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['minimum_rssi_threshold']"
                                              :rules="[vRules.required]"
                                              density="compact" hint="dBm" label="Minimum RSSI" type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="bleWifiFormData['debounce_interval_in_seconds']"
                                          :items="[1,2,3,4,5,6,7,8,9,10]"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Debounce time in seconds"
                                />
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="bleWifiFormData['reporting_interval_in_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact" label="Reporting interval in seconds"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-combobox
                                    v-model="bleWifiFormData['name_prefixes']"
                                    :items="[]"
                                    :rules="[vRules.required]"
                                    chips
                                    hint="Press Enter after prefix"
                                    label="Name Prefixes"
                                    multiple
                                ></v-combobox>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-combobox
                                    v-model="bleWifiFormData['address_prefixes']"
                                    @update:model-value="validateFormat"
                                    :items="[]"
                                    :rules="[vRules.required]"
                                    chips
                                    hint="Press Enter after prefix"
                                    label="Address Prefixes"
                                    multiple
                                ></v-combobox>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-checkbox v-model="bleWifiFormData['driver_id_scan']"
                                            label="Driver ID Scan"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-checkbox v-model="bleWifiFormData['report_on_change']"
                                            label="Report only on changes"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'push_button'">
                        <v-row>
                            <v-col class="py-0" cols="6">
                                <v-checkbox v-model="pushButtonFormData['report_press']" label="Report Press"/>
                            </v-col>
                            <v-col class="py-0" cols="6">
                                <v-checkbox v-model="pushButtonFormData['report_release']" label="Report Release"/>
                            </v-col>

                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="pushButtonFormData['label']"
                                              :rules="[vRules.required]" density="compact" label="Label"/>
                            </v-col>

                            <v-col class="py-0" cols="6">
                                <v-text-field v-model="pushButtonFormData['debounce_interval']"
                                              :rules="[vRules.required]" density="compact" label="Debounce Interval"/>
                            </v-col>
                            <v-col class="py-0" cols="6">
                                <v-text-field v-model="pushButtonFormData['report_interval']"
                                              :rules="[vRules.required]" density="compact" label="Report Interval"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="type.toLowerCase() === 'io'">
                        <v-row>
                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="extGpioFormData['label']"
                                              :rules="[vRules.required, vRules.maxLength(64)]"
                                              density="compact" label="Template name"/>
                            </v-col>

                            <v-col class="pb-0 pt-3" cols="12">
                                <h4 class="text-subtitle-1">Digital Output</h4>
                                <p class="text-caption text-medium-emphasis mb-1">
                                    The line the tracker drives. Wire it to a relay, LED, buzzer or beacon.
                                </p>
                                <v-checkbox v-model="extGpioFormData['gpo']" density="compact" hide-details
                                            label="Enable digital output"/>
                            </v-col>

                            <v-col v-if="extGpioFormData['gpo']" class="py-0" cols="12">
                                <IoFunctionPicker :model-value="extGpioFormData"
                                                  @update:fields="onIoFunctionChange"
                                                  @legacy-migration="ioLegacyMigration = true"/>
                                <v-alert v-if="ioLegacyMigration"
                                         density="compact" type="warning" variant="tonal"
                                         class="mt-2"
                                         text="This template uses the legacy output format and will be automatically upgraded to the new motion-field format when saved. The output behaviour is unchanged."/>
                            </v-col>

                            <v-col v-if="extGpioFormData['gpo']" class="py-0" cols="12">
                                <v-expansion-panels variant="accordion">
                                    <v-expansion-panel title="Advanced output settings">
                                        <v-expansion-panel-text>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select v-model="extGpioFormData['gpo_default_state']"
                                                              :items="[
                                                                  {value: true, title: 'Active high (most loads)'},
                                                                  {value: false, title: 'Active low (inverted)'},
                                                              ]"
                                                              density="compact"
                                                              label="Output polarity"
                                                              hint="Most loads turn on when the wire is driven high. Pick active low only if your load is normally on."
                                                              persistent-hint/>
                                                </v-col>
                                                <v-col v-if="ioPickerAdvanced" class="py-1" cols="6">
                                                    <v-text-field v-model.number="extGpioFormData['ext_gpi_motion_period_ms']"
                                                                  :min="0" :max="65535"
                                                                  density="compact" type="number"
                                                                  label="Pulse period (ms)"
                                                                  hint="100 to 65535, or 0 for default"
                                                                  persistent-hint/>
                                                </v-col>
                                                <v-col v-if="ioPickerAdvanced" class="py-1" cols="6">
                                                    <v-text-field v-model.number="extGpioFormData['ext_gpi_motion_pulse_width_ms']"
                                                                  :min="0" :max="65535"
                                                                  density="compact" type="number"
                                                                  label="Pulse width (ms)"
                                                                  hint="10 ms minimum, must be less than period"
                                                                  persistent-hint/>
                                                </v-col>
                                                <v-col v-if="ioPickerAdvanced" class="py-1" cols="12">
                                                    <v-row>
                                                        <v-col cols="3">
                                                            <v-checkbox v-model="extGpioFormData['ext_gpi_idle_state']"
                                                                        :true-value="1" :false-value="0"
                                                                        density="compact" hide-details
                                                                        label="Idle state ON"/>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-checkbox v-model="extGpioFormData['ext_gpi_motion_pulse_start']"
                                                                        :true-value="1" :false-value="0"
                                                                        density="compact" hide-details
                                                                        label="Pulse on start"/>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-checkbox v-model="extGpioFormData['ext_gpi_motion_pulse_stop']"
                                                                        :true-value="1" :false-value="0"
                                                                        density="compact" hide-details
                                                                        label="Pulse on stop"/>
                                                        </v-col>
                                                        <v-col cols="3">
                                                            <v-select v-model="extGpioFormData['ext_gpi_motion_during']"
                                                                      :items="[
                                                                          {value: 0, title: 'None'},
                                                                          {value: 1, title: 'Sustain'},
                                                                          {value: 2, title: 'Pulse'},
                                                                      ]"
                                                                      density="compact" hide-details
                                                                      label="During motion"/>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <p class="text-caption text-medium-emphasis mt-1 mb-0">
                                                                Tip: when Idle state is ON, pulse presets produce a brief LOW dip instead of a HIGH spike.
                                                            </p>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>

                            <v-col class="pb-0 pt-3" cols="12">
                                <h4 class="text-subtitle-1">Digital Input</h4>
                                <p class="text-caption text-medium-emphasis mb-1">
                                    The line the tracker reads. Wire it to a switch, sensor, or ignition feed.
                                </p>
                                <v-checkbox v-model="extGpioFormData['gpi']" density="compact" hide-details
                                            label="Enable digital input"/>
                            </v-col>

                            <v-col v-if="extGpioFormData['gpi']" class="py-0" cols="12">
                                <v-select v-model="extGpioFormData['ext_gpo_notify_on_edge']"
                                          :items="[
                                              {value: 0, title: 'Either change (signal turns on or off)'},
                                              {value: 1, title: 'Signal turns on'},
                                              {value: 2, title: 'Signal turns off'},
                                          ]"
                                          density="compact" label="Send a notification when"/>
                            </v-col>

                            <v-col v-if="extGpioFormData['gpi']" class="py-0" cols="12">
                                <v-expansion-panels variant="accordion">
                                    <v-expansion-panel title="Advanced input settings">
                                        <v-expansion-panel-text>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select v-model="extGpioFormData['ext_gpo_active_level']"
                                                              :items="[
                                                                  {value: 0, title: 'No (signal is on when the wire is high)'},
                                                                  {value: 1, title: 'Yes (signal is on when the wire is low)'},
                                                              ]"
                                                              density="compact" label="Invert input polarity"/>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field v-model.number="extGpioFormData['gpi_debounce_interval']"
                                                                  :min="0"
                                                                  density="compact" type="number"
                                                                  label="Filter short pulses (ms)"
                                                                  hint="Ignore changes shorter than this"
                                                                  persistent-hint/>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field v-model.number="extGpioFormData['gpi_report_interval']"
                                                                  :min="0"
                                                                  density="compact" type="number"
                                                                  label="Cooldown between events (ms)"
                                                                  hint="Time before another event can fire"
                                                                  persistent-hint/>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <v-row>
                            <v-col cols="6">
                                <v-switch v-model="generalFormData['periodic_reboot_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="Periodic Reboot Status"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-switch v-model="generalFormData['lte_scan_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="LTE Scan Status"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-switch v-model="generalFormData['ble_scan_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="BLE Scan Status"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-switch v-model="generalFormData['wifi_scan_status']"
                                          :rules="[vRules.required]"
                                          color="primary"
                                          density="compact"
                                          label="Wifi Scan Status"
                                />
                            </v-col>

                            <v-col class="py-0" cols="12">
                                <v-text-field v-model="generalFormData['label']"
                                              :rules="[vRules.required,vRules.maxLength(64)]"
                                              density="compact" label="Label"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['network_diagnostics_status']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Network Diagnostic Status"
                                              type="number"
                                />
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gateway_timeout_in_milli_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint=" Milliseconds"
                                              label="Gateway Timeout"
                                              type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['movement_starts_alert_flag']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Movement Start Alert Flag"
                                              type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['network_registration_timeout_in_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Network Registration Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['periodic_reboot_interval_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Periodic Reboot Interval"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['server_acknowledgment_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Server Acknowledgment"
                                              type="number"/>
                            </v-col>


                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['network_diagnostics_period_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Network Diagnostic Period"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['heartbeat_packet_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Heartbeat Packet"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['movement_progress_alert_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Movement Progress Alert"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['activity_threshold_x_axes']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Activity Threshold X Axes"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['activity_threshold_y_axes']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Activity Threshold Y Axes"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['activity_threshold_z_axes']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Activity Threshold Z Axes"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['seconds_per_sample']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Seconds per sample"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['minimum_activity_interrupts_needed_per_sample']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Per sample"
                                              label="Minimum activity interrupts needed"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['fifo_size']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="FIFO Size"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['fifo_movement_start_thresholds']"
                                              @blur="updateMovementFifoThreshold"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="FIFO movement starts thresholds"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['fifo_movement_continue_thresholds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="FIFO movement continue thresholds"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gps_minimum_accuracy_idle']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Idle"
                                              label="GPS minimum accuracy (Idle)"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gps_minimum_accuracy_movement']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Movement"
                                              label="GPS minimum accuracy (Movement)"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gps_fix_timeout_idle_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Idle in seconds"
                                              label="GPS fix timeout (Idle)"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['gps_fix_timeout_movement_seconds']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Movement in seconds"
                                              label="GPS fix timeout (Movement)"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['packet_retransmit_attempts']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Packet Retransmit attempts"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['lte_scan_trigger_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="LTE Scan Trigger Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['ble_scan_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="BLE Scan Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['ble_scan_trigger_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="BLE Scan Trigger Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['wifi_scan_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Wifi Scan Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['wifi_scan_trigger_timeout']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Wifi Scan Trigger Timeout"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['max_stationary_progress_interval']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              hint="Seconds"
                                              label="Max Stationary Progress Interval"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['ble_scan_interval']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Ble Scan Interval"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['ble_scan_window']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Ble Scan Window"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['movement_instantaneous_fifo_threshold']"
                                              :rules="[vRules.required]"
                                              density="compact"
                                              label="Movement Instantaneous FIFO Threshold"
                                              type="number"/>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-text-field v-model="generalFormData['movement_algo_type']"
                                              density="compact"
                                              label="Movement Algo Type"
                                              type="number"/>
                            </v-col>
                            <v-col class="py-0" cols="12" sm="6">
                                <v-switch v-model="generalFormData['ignition_on_ext_gpi1']"
                                          color="primary"
                                          density="compact"
                                          hide-details
                                          label="Ignition is on EXT GPI1"/>
                                <p class="text-caption text-medium-emphasis">
                                    Orion Fleet only. The tracker watches EXT GPI1 itself, with no External I/O template attached, and reports movement for as long as the line is active.
                                </p>
                            </v-col>

                            <v-col class="py-0" cols="12" sm="6">
                                <v-select v-model="generalFormData['ignition_ext_gpi1_active_level']"
                                          :disabled="!generalFormData['ignition_on_ext_gpi1']"
                                          :items="ignitionActiveLevels"
                                          density="compact"
                                          item-title="label"
                                          item-value="value"
                                          label="EXT GPI1 Active State"/>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import "leaflet-draw";
import L from "leaflet";
import {ref, reactive, computed} from "vue";
import IoFunctionPicker from "./IoFunctionPicker.vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {useAuthStore} from "@/stores/authStore";
import {LMap, LTileLayer} from "@vue-leaflet/vue-leaflet";
import {GeoSearchControl, OpenStreetMapProvider} from "leaflet-geosearch";
import {mapTiles} from "@/composables/mapConfig";

const props = defineProps({
    modelValue: Boolean,
    type: String,
    template: {
        type: Object
    }
});
const mapContainer = ref();
const errors = ref([]);
const snackbar = useSnackbarStore();
const userPrefersKm = computed(() => useAuthStore().configs?.distance_unit === 'km');
const speedUnitLabel = computed(() => userPrefersKm.value ? 'kph' : 'mph');

/** Convert speed threshold from MPH (DB storage) to display unit */
const mphToDisplay = (mph) => mph ? (userPrefersKm.value ? Math.round(mph * 1.609) : mph) : null;
/** Convert speed threshold from display unit to MPH (DB storage) */
const displayToMph = (val) => userPrefersKm.value ? Math.round(val / 1.609) : val;
const dialogSwitch = ref(props.modelValue);
const pushButtonFormData = reactive({
    label: props.template.label,
    report_press: !!props.template.report_press,
    report_release: !!props.template.report_release,
    debounce_interval: props.template.debounce_interval,
    report_interval: props.template.report_interval,
    company_id: props.template.company_id,
});
const speedFormData = reactive({
    label: props.template.label,
    company_id: props.template.company_id,
    speed_threshold: mphToDisplay(props.template.speed_threshold),
    minimum_violations_in_seconds: props.template.minimum_violations_in_seconds,
    minimum_alert_interval_seconds: props.template.minimum_alert_interval_seconds,
});
// Matches the firmware's own encoding so there is one convention rather than two:
// EXT_GPO_ACTIVE_LEVEL_HIGH = 0, EXT_GPO_ACTIVE_LEVEL_LOW = 1. Active high is also
// what the firmware assumes when no External I/O config is present.
const ignitionActiveLevels = [
    {value: 0, label: 'Active High - ignition on when the line is high'},
    {value: 1, label: 'Active Low - ignition on when the line is low'},
];
const generalFormData = reactive({
    label: props.template.label,
    company_id: props.template.company_id,

    gateway_timeout_in_milli_seconds: props.template.gateway_timeout_in_milli_seconds ?? 5000,
    network_registration_timeout_in_seconds: props.template.network_registration_timeout_in_seconds ?? 120,
    periodic_reboot_status: !!props.template.periodic_reboot_status ?? false,
    periodic_reboot_interval_seconds: props.template.periodic_reboot_interval_seconds ?? 0,
    server_acknowledgment_seconds: props.template.server_acknowledgment_seconds ?? 2000,
    network_diagnostics_status: props.template.network_diagnostics_status ?? null,
    network_diagnostics_period_seconds: props.template.network_diagnostics_period_seconds ?? 28800,
    heartbeat_packet_seconds: props.template.heartbeat_packet_seconds ?? 10800,
    movement_starts_alert_flag: props.template.movement_starts_alert_flag ?? 7,
    movement_progress_alert_seconds: props.template.movement_progress_alert_seconds ?? 30,
    activity_threshold_x_axes: props.template.activity_threshold_x_axes ?? 33,
    activity_threshold_y_axes: props.template.activity_threshold_y_axes ?? 33,
    activity_threshold_z_axes: props.template.activity_threshold_z_axes ?? 33,
    fifo_size: props.template.fifo_size ?? 120,
    seconds_per_sample: props.template.seconds_per_sample ?? 0,
    minimum_activity_interrupts_needed_per_sample: props.template.minimum_activity_interrupts_needed_per_sample ?? 1,
    fifo_movement_start_thresholds: props.template.fifo_movement_start_thresholds ?? 5,
    fifo_movement_continue_thresholds: props.template.fifo_movement_continue_thresholds ?? 5,
    gps_minimum_accuracy_idle: props.template.gps_minimum_accuracy_idle ?? 6,
    gps_minimum_accuracy_movement: props.template.gps_minimum_accuracy_movement ?? 25,
    gps_fix_timeout_idle_seconds: props.template.gps_fix_timeout_idle_seconds ?? 300,
    gps_fix_timeout_movement_seconds: props.template.gps_fix_timeout_movement_seconds ?? 120,
    packet_retransmit_attempts: props.template.packet_retransmit_attempts ?? 3,
    lte_scan_status: !!props.template.lte_scan_status ?? true,
    lte_scan_trigger_timeout: props.template.lte_scan_trigger_timeout ?? 120,
    ble_scan_status: !!props.template.ble_scan_status ?? false,
    ble_scan_timeout: props.template.ble_scan_timeout ?? 10,
    ble_scan_trigger_timeout: props.template.ble_scan_trigger_timeout ?? 30,
    wifi_scan_status: !!props.template.wifi_scan_status ?? false,
    wifi_scan_timeout: props.template.wifi_scan_timeout ?? 10,
    wifi_scan_trigger_timeout: props.template.wifi_scan_trigger_timeout ?? 30,
    max_stationary_progress_interval: props.template.max_stationary_progress_interval ?? 300,
    ble_scan_interval: props.template.ble_scan_interval ?? 511,
    ble_scan_window: props.template.ble_scan_window ?? 48,
    movement_instantaneous_fifo_threshold: props.template.movement_instantaneous_fifo_threshold ?? null,
    movement_algo_type: props.template.movement_algo_type ?? null,
    // v-switch compares with deepEqual, so an int 1 would render as off.
    ignition_on_ext_gpi1: !!props.template.ignition_on_ext_gpi1,
    ignition_ext_gpi1_active_level: props.template.ignition_ext_gpi1_active_level ?? 0,
});
const geofenceFormData = reactive({
    type: props.template.type,
    label: props.template.label,
    company_id: props.template.company_id,
    radius: props.template.radius,
    center_lat: props.template.center_lat,
    center_lon: props.template.center_lon,
    enter_or_exit: props.template.enter_or_exit,
    trigger_delay: props.template.trigger_delay,
    minimum_violation_time: props.template.minimum_violation_time,
    polygon_coordinates: props.template?.polygon_coordinates?.map((coordinate) => {
        return {'lat': coordinate.latitude, 'lng': coordinate.longitude};
    }) ?? [],
});
const bleWifiFormData = reactive({
    type: props.template.type,
    label: props.template.label,
    company_id: props.template.company_id,
    scan_interval_in_seconds: props.template.scan_interval_in_seconds,
    scan_window_in_seconds: props.template.scan_window_in_seconds,
    minimum_rssi_threshold: props.template.minimum_rssi_threshold,
    debounce_interval_in_seconds: props.template.debounce_interval_in_seconds,
    reporting_interval_in_seconds: props.template.reporting_interval_in_seconds,
    driver_id_scan: !!props.template.driver_id_scan ?? null,
    report_on_change: !!props.template.report_on_change ?? null,
    name_prefixes: props.template.name_prefixes,
    address_prefixes: props.template.address_prefixes,
});
const lightSensorFormData = reactive({
    label: props.template.label,
    lux_value: props.template.lux_value,
    company_id: props.template.company_id,
    light_to_dark: !!props.template.light_to_dark,
    dark_to_light: !!props.template.dark_to_light,
    debounce_interval_in_seconds: props.template.debounce_interval_in_seconds,
    reporting_interval_in_seconds: props.template.reporting_interval_in_seconds,
    light_profile: props.template.light_profile,
});
const temperatureSensorFormData = reactive({
    label: props.template.label,
    company_id: props.template.company_id,
    low_reporting_status: !!props.template.low_reporting_status,
    high_reporting_status: !!props.template.high_reporting_status,
    low_threshold_celsius: props.template.low_threshold_celsius,
    high_threshold_celsius: props.template.high_threshold_celsius,
    debounce_interval_in_seconds: props.template.debounce_interval_in_seconds,
    reporting_interval_in_seconds: props.template.reporting_interval_in_seconds,
});
const extGpioFormData = reactive({
    label: props.template.label,
    gpi: !!props.template.gpi,
    gpo: !!props.template.gpo,
    gpo_output: !!props.template.gpo_output,
    gpo_default_state: !!props.template.gpo_default_state,
    gpi_debounce_interval: props.template.gpi_debounce_interval,
    gpi_report_interval: props.template.gpi_report_interval,
    ext_gpi_idle_state: Number(props.template.ext_gpi_idle_state) || 0,
    ext_gpi_motion_pulse_start: Number(props.template.ext_gpi_motion_pulse_start) || 0,
    ext_gpi_motion_during: Number(props.template.ext_gpi_motion_during) || 0,
    ext_gpi_motion_pulse_stop: Number(props.template.ext_gpi_motion_pulse_stop) || 0,
    ext_gpi_motion_period_ms: Number(props.template.ext_gpi_motion_period_ms) || 0,
    ext_gpi_motion_pulse_width_ms: Number(props.template.ext_gpi_motion_pulse_width_ms) || 0,
    ext_gpo_active_level: Number(props.template.ext_gpo_active_level) || 0,
    ext_gpo_notify_on_edge: Number(props.template.ext_gpo_notify_on_edge) || 0,
    company_id: props.template.company_id,
});
const ioPickerAdvanced = ref(false);
const ioLegacyMigration = ref(false);
function onIoFunctionChange(event) {
    ioPickerAdvanced.value = !!event.advanced;
    if (event.advanced) return;
    Object.assign(extGpioFormData, event.fields);
}

const emits = defineEmits(['update:modelValue', 'updateTemplate']);
const urlPrefix = computed(() => {
    switch (props.type.toLowerCase()) {
        case 'geofence':
            return 'monitoring/geofence';
        case 'light':
            return 'monitoring/light-sensor'
        case 'temperature':
            return 'monitoring/temperature'
        case 'speed':
            return 'monitoring/speed'
        case 'push_button':
            return 'monitoring/push-button'
        case 'io':
            return 'monitoring/ext-gpio'
        case 'ble_tag':
        case 'wifi_tag':
            return 'monitoring/ble-wifi'
        default:
            return 'monitoring/general'
    }
});
const title = computed(() => {
    switch (props.type.toLowerCase()) {
        case 'geofence':
            return "Real-Time Geo Fence Template"
        case 'light':
            return "Light Sensor Template"
        case 'temperature':
            return "Temperature Sensor Template"
        case 'ble_tag':
            return "BLE Tag Scan template"
        case 'wifi_tag':
            return "Wifi Tag Scan template"
        case 'speed':
            return "Speed Template"
        case 'push_button':
            return "Push Button Template"
        case 'io':
            return "Input Output Template"
        default:
    }
})
const validateFormat = () => {
    if (bleWifiFormData['address_prefixes']?.length) {
        bleWifiFormData['address_prefixes'] = bleWifiFormData['address_prefixes'].filter(addr => {
            return /^([0-9A-Z]{2}):([0-9A-Z]{2}):([0-9A-Z]{2})$/i.test(addr);
        });
    }
}
const mapIsReady = () => {
    const map = mapContainer.value.leafletObject;
    map.attributionControl.remove();
    /*Add Draw Geo Search Control*/
    const geoSearchOptions = new GeoSearchControl({
        style: "bar",
        autoClose: true,
        keepResult: true,
        showMarker: false,
        searchLabel: "Enter address",
        provider: new OpenStreetMapProvider({searchUrl: mapTiles.searchUrl, reverseUrl: mapTiles.reverseUrl}),
    });
    map.addControl(geoSearchOptions);

    /*Add Draw Tool Bar Control*/
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);
    const drawControl = new L.Control.Draw({
        draw: {
            circle: props.template.type === 0,
            polygon: props.template.type === 1 ? {
                status: false,
                showArea: true,
                allowIntersection: false, // Restricts shapes to simple polygons
                drawError: {
                    color: '#9d1212', // Color the shape will turn when intersects
                    message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
                }
            } : false,
            // disable toolbar item by setting it to false
            marker: false,
            polyline: false,
            rectangle: false,
            circlemarker: false,
        },
        edit: {
            remove: false,
            featureGroup: drawnItems
        }
    });
    map.addControl(drawControl);

    if (props.template.type === 0) {
        drawnItems.addLayer(L.circle([props.template.center_lat, props.template.center_lon], {
            // editable: true,
            radius: props.template.radius,
        }));
        map.setView([props.template.center_lat, props.template.center_lon], 14);
    } else if (props.template.type === 1) {
        const polygon = L.polygon(geofenceFormData['polygon_coordinates'], {
            // editable: true,
        });
        drawnItems.addLayer(polygon);
        const bounds = drawnItems.getBounds();
        if (bounds._northEast && bounds._southWest) {
            map.fitBounds(drawnItems.getBounds());
        }
    }
    map.on('draw:created', function (e) {
        drawnItems.eachLayer(function (layer) {
            drawnItems.removeLayer(layer);
        });

        let type = e.layerType,
            layer = e.layer;

        if (type === 'circle') {
            geofenceFormData['type'] = 0;
            geofenceFormData['radius'] = layer.getRadius();
            geofenceFormData['center_lat'] = layer.getLatLng().lat;
            geofenceFormData['center_lon'] = layer.getLatLng().lng;
        } else if (type === 'polygon') {
            geofenceFormData['type'] = 1;
            geofenceFormData['location_changed'] = 1;
            geofenceFormData['polygon_coordinates'] = layer.getLatLngs()[0];
        }
        drawnItems.addLayer(layer);
    });

    map.on('draw:edited', function (e) {
        e.layers.eachLayer(function (layer) {
            if (layer instanceof L.Circle) {
                geofenceFormData['type'] = 0;
                geofenceFormData['radius'] = layer.getRadius();
                geofenceFormData['center_lat'] = layer.getLatLng().lat;
                geofenceFormData['center_lon'] = layer.getLatLng().lng;
            } else if (layer instanceof L.Polygon) {
                geofenceFormData['type'] = 1;
                geofenceFormData['location_changed'] = 1;
                geofenceFormData['polygon_coordinates'] = layer.getLatLngs()[0];
            }
        });
    });

    map.on('draw:deleted', function (e) {
        drawnItems.eachLayer(function (layer) {
            drawnItems.removeLayer(layer);
        });
        geofenceFormData['type'] = 0;
        geofenceFormData['radius'] = null;
        geofenceFormData['center_lat'] = null;
        geofenceFormData['center_lon'] = null;
        geofenceFormData['polygon_coordinates'] = null;
    });
}
const updateMovementFifoThreshold = () => {
    if (!generalFormData['movement_instantaneous_fifo_threshold']) {
        generalFormData['movement_instantaneous_fifo_threshold'] = generalFormData['fifo_movement_start_thresholds'];
    }
}

const editTemplate = () => {
    errors.value = [];
    let data = null;
    switch (props.type.toLowerCase()) {
        case 'geofence':
            data = geofenceFormData;
            if (!geofenceFormData['label']) {
                errors.value.push("Label field is required");
            }
            if (geofenceFormData['type'] === 0) {
                if (!geofenceFormData['radius'] || !geofenceFormData['center_lat'] || !geofenceFormData['center_lat']) {
                    errors.value.push("You must draw circle on map");
                }
            } else {
                if (!geofenceFormData['polygon_coordinates']) {
                    errors.value.push("You must draw polygon on map");
                }
                if (geofenceFormData['polygon_coordinates'].length > 32) {
                    errors.value.push("Polygon can have max 32 points");
                }
            }
            break
        case 'light':
            data = lightSensorFormData;
            if (!lightSensorFormData['label']) {
                errors.value.push("Label field is required");
            }
            if (!lightSensorFormData['light_profile']) {
                errors.value.push("You must select one of the light profile");
            }
            break
        case 'temperature':
            data = temperatureSensorFormData;
            if (!temperatureSensorFormData['label']) {
                errors.value.push("Label field is required");
            }
            if (temperatureSensorFormData['low_threshold_celsius'] === null || temperatureSensorFormData['low_threshold_celsius'] === '') {
                errors.value.push("Low threshold field is required");
            }
            if (temperatureSensorFormData['high_threshold_celsius'] === null || temperatureSensorFormData['high_threshold_celsius'] === '') {
                errors.value.push("High threshold field is required");
            }
            break
        case 'speed':
            data = {...speedFormData, speed_threshold: displayToMph(speedFormData['speed_threshold'])};
            if (!speedFormData['label'] || !speedFormData['speed_threshold'] || !speedFormData['minimum_violations_in_seconds'] || !speedFormData['minimum_alert_interval_seconds']) {
                errors.value.push("All fields are required");
            }
            break
        case 'push_button':
            data = pushButtonFormData;
            if (!pushButtonFormData['label'] || !pushButtonFormData['debounce_interval'] || !pushButtonFormData['report_interval']) {
                errors.value.push("Label & Interval fields are required");
            }
            break
        case 'io': {
            const { valid: _ioValid, ...ioPayload } = extGpioFormData;
            data = {
                ...ioPayload,
                gpo_output: ioPayload.gpo_output ? 1 : 0,
                gpo_default_state: ioPayload.gpo_default_state ? 1 : 0,
            };
            if (!extGpioFormData['label']) {
                errors.value.push("Template name is required");
            }
            // B7: at least one of input or output must be enabled, otherwise the template is a no-op
            if (!extGpioFormData['gpi'] && !extGpioFormData['gpo']) {
                errors.value.push("Enable at least one of digital input or digital output");
            }
            if (extGpioFormData['gpi']) {
                // B26: parity with mobile/firmware ranges. Treat non-finite values
                // (blank, NaN) as invalid rather than letting Number(0) short-circuit
                // past the range check.
                const debounce = Number(extGpioFormData['gpi_debounce_interval']);
                if (!Number.isFinite(debounce) || debounce < 1 || debounce > 255) {
                    errors.value.push("Input filter must be between 1 and 255 ms");
                }
                const reportInt = Number(extGpioFormData['gpi_report_interval']);
                if (!Number.isFinite(reportInt) || reportInt < 1 || reportInt > 65535) {
                    errors.value.push("Cooldown between events must be between 1 and 65535 ms");
                }
            }
            // CB5: catch sub-100 periods client-side so customers see the limit before the round-trip
            const periodMs = Number(extGpioFormData['ext_gpi_motion_period_ms']);
            const widthMs = Number(extGpioFormData['ext_gpi_motion_pulse_width_ms']);
            if (periodMs > 0 && periodMs < 100) {
                errors.value.push("Pulse period must be 0 (default) or at least 100 ms");
            }
            // B7: pulse-on-start/end is mutually exclusive with sustain/beacon during motion
            const pulseStart = Number(extGpioFormData['ext_gpi_motion_pulse_start']);
            const pulseStop = Number(extGpioFormData['ext_gpi_motion_pulse_stop']);
            const during = Number(extGpioFormData['ext_gpi_motion_during']);
            if ((pulseStart === 1 || pulseStop === 1) && during !== 0) {
                errors.value.push("Pulse-on-start/end cannot be combined with Sustain or Beacon during motion");
            }
            if (pulseStart === 1 && widthMs === 0) {
                errors.value.push("Pulse width must be greater than zero when pulse-on-start is enabled");
            }
            if (widthMs > 0 && periodMs > 0 && widthMs >= periodMs) {
                errors.value.push("Pulse width must be less than period for beacon mode");
            }
            // Belt-and-braces: the legacy gpo_output flag is mutually exclusive with
            // every motion field, mirroring the API validator added in PR #871. The
            // preset emitter clears gpo_output, but Advanced mode can still leave it
            // set, so flag it here for a clean client-side error rather than a 422.
            if (extGpioFormData['gpo_output'] && (during !== 0 || pulseStart === 1 || pulseStop === 1)) {
                errors.value.push("Legacy 'Drive output while moving' cannot be combined with motion presets. Pick a single behaviour.");
            }
            break
        }
        case 'ble_tag':
        case 'wifi_tag':
            data = bleWifiFormData;
            if (!bleWifiFormData['label'] ||
                !bleWifiFormData['scan_interval_in_seconds'] ||
                !bleWifiFormData['scan_window_in_seconds'] ||
                !bleWifiFormData['minimum_rssi_threshold'] ||
                !bleWifiFormData['debounce_interval_in_seconds'] ||
                !bleWifiFormData['reporting_interval_in_seconds'] ||
                !bleWifiFormData['name_prefixes'] ||
                !bleWifiFormData['address_prefixes']
            ) {
                errors.value.push("All fields are required");
            }
            break
        default:
            data = generalFormData;
            break
    }
    if (errors.value.length) {
        document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        return false;
    }

    send('put', `${urlPrefix.value}-templates/${props.template.id}`, data)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateTemplate', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
